// extracted by mini-css-extract-plugin
module.exports = {"landingPageContent":"LandingPage_landingPageContent__KgFF8","IPFSLimitedGrid":"LandingPage_IPFSLimitedGrid__qWhpr"};